export default __webpack_public_path__ + "static/media/random_remera_front.cf6079be.png";